import dayjs from 'dayjs';

export const formatByTemplate = (date: Date, template: string) => dayjs(date).format(template);
